<template>
  <div>
    <div class="vx-row"> <!--v-show="payrollType.createPayrollTypeId == 2 || payrollType.createPayrollTypeId == 3"> -->
      <div class="vx-col sm:w-1/6  w-full md:mt-8 mb-6">
        <div class="demo-alignment">
          <span class="mr-4">All Employee</span>
          <div class="flex">
            <vs-switch v-model="uploadSwitch">All Employees</vs-switch>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row" v-show="!uploadSwitch">
      <div class="vx-col sm:w-1/12 w-full mb-2">
        <span class="text-sm">Employee Code</span> <span>*</span>
        <vs-input name="code" class="w-full" placeholder="Code" v-model="employeeCode"></vs-input>
      </div>
    </div>
    <div class="vx-row" >
      <div class="vx-col sm:w-2/12 w-full mb-2">
        <span class="text-sm">Calendar Year</span><span style="color:red">*</span>
        <v-select v-validate="'required'" name="calendar_year" label="year" v-model="calendarYear"
          :options="getYearsLookup" class="w-full" />
      </div>
    </div>
    <div class="flex justify-between flex-wrap mt-5">
      <span />
      <vs-button @click="onGenerateBIR()" color="success" type="filled" icon-pack="feather" icon="icon-download">Generate Reports</vs-button>
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Swal from 'sweetalert2'
import axios from '@/axios.js'
export default {
  data() {
    return {
      employeeCode: '',
      calendarYear: null,
      uploadSwitch: true
    }
  },
  computed: {
    getYearsLookup() {
      const year = new Date().getFullYear()
      return Array.from({ length: year - 2020 }, (value, index) => 2021 + index)
    },
    tenantName() {
      return (id) => this.$store.getters['tenants/tenantName'](id)
    },
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    onGenerateBIR() {
      this.$vs.loading()
      var logoPath = ''
      let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId)
      var pDate = moment(new Date()).format('YYYYMMDD')

      if (tenant.photoId != null) {
        this.$store.dispatch('getFile', tenant.photoId) //Get filePath of Company Logo
          .then((response) => {
            logoPath = response.data.path

          })
      }
      const data = {
                serverName: tenant.secretKey,
                dbName: tenant.apiKey,
                userName: '',
                password: '',
                companyCode: tenant.code,
                companyName: tenant.name,
                address: tenant.address,
                photoURL: logoPath,
                createPayrollId: 0,//this.createPayroll.createPayrollId,
                printedBy: this.$store.state.AppActiveUser.uid,
                reportName:['BIR2316ALL'],//['PayrollSummary', 'PayrollEarnings'],
                payOutDate: pDate, //moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
                creditDate: pDate,
                passwordToOpen: null,
                monthName: '',
                yearScope: this.calendarYear,
                reportType: 'BIR2316ALL',
                userId: [this.$store.state.AppActiveUser.uid]
            }

            // this.$vs.loading()
      this.$store.dispatch('payroll/GenerateReports', data)
            .then(() => {

          var zipFileName = tenant.code + '_BIR2316ALL.zip'

          axios.get(`/api/reports/OtherReports?dbName=${tenant.code}&fileName=${zipFileName}&reportType=BIR2316ALL&monthName=0&yearScope=${this.calendarYear}`
            , { reportProgress: true, responseType: 'blob' })
            .then((response) => {
              this.$vs.loading.close()
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', zipFileName);
              document.body.appendChild(link);
              link.click();

              Swal.fire({ title: 'Done',
                html: 'BIR 2316 Reports Generated',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  this.$vs.loading.close()
                  this.$router.go()
                } })
            })
            .catch((error) => {
              this.$vs.loading.close()
              this.$alert(error.message, 'Error', 'error')
            })
      })
    }
  }
}
</script>
